import ParameterErrors from '../errors/ParameterErrors';
import ParseError from '../errors/ParseError';
import Configurator from './Configurator';
import FeatureForPlot from '../features/FeatureForPlot';
import FeatureForHouseType from '../features/FeatureForHouseType';
import Feature from '../features/Feature';
const { throwNotProvided, throwNotOfType} = ParameterErrors;
export default class LatestSiteInfo{
	constructor(props){
		const {configurators, latestPlotInfos, latestHouseTypeInfos}=props;
		if(!configurators)throwNotProvided('configurators');
		this._configurators = configurators;
		if(!latestPlotInfos)throwNotProvided('latestPlotInfos');
		this._latestPlotInfos = latestPlotInfos;
		if(!latestHouseTypeInfos)throwNotProvided('latestHouseTypeInfos');
		this._latestHouseTypeInfos = latestHouseTypeInfos;
	}
	get configurators(){
		return this._configurators;
	}
	get latestPlotInfos(){
		return this._latestPlotInfos;
	}
	get latestHouseTypeInfos(){
		return this._latestHouseTypeInfos;
	}
	static fromJSON(jObject){
		const features = jObject.features?.map(jObjectFeature =>new Feature(jObjectFeature));
		const getFeatureById = (id)=>features?.filter(feature=>feature.id===id)[0];
		const latestPlotInfos = jObject.latestPlotInfos;
		latestPlotInfos?.forEach(latestPlotInfo=>{
			if(latestPlotInfo.featuresForPlot)
				latestPlotInfo.featuresForPlot = latestPlotInfo.featuresForPlot.map(featureForPlot=>{
					featureForPlot.getFeatureById = getFeatureById;
					return new FeatureForPlot(featureForPlot);
				});
			
		});
		const latestHouseTypeInfos = jObject.latestHouseTypeInfos;
		
		latestHouseTypeInfos?.forEach(latestHouseTypeInfo=>{
			if(!latestHouseTypeInfo.featuresForHouseType)return;
			latestHouseTypeInfo.featuresForHouseType = latestHouseTypeInfo.featuresForHouseType.map(featureForHouseType=>{
				featureForHouseType.getFeatureById = getFeatureById;
				return new FeatureForHouseType(featureForHouseType);
			});
		});
		return new LatestSiteInfo({
			features,
			configurators:jObject.configurators?.map(jObjectConfigurator=>Configurator.fromJSON(jObjectConfigurator)),
			latestPlotInfos,
			latestHouseTypeInfos
		});
	}
}